<template>
  <div
    :class="getLoading && 'bg-white'"
    class="flex-auto px-4 lg:px-10 py-10 pt-0"
  >
    <div
      v-if="getLoading"
      class="bg-white w-full flex flex-col py-10 justify-center items-center"
    >
      <!-- https://gannon.tv/intro -->
      <img width="260" src="@/assets/imgs/loading.gif" alt="loading" />
      <h3>Loading...</h3>
    </div>
    <div v-if="!getLoading && !hasContent">
      <p class="justify-center items-center flex mt-10">
        This component has no attributes
      </p>
    </div>
    <div v-if="!getLoading && !hasInstance && hasContent">
      <p class="justify-center items-center flex mt-10">
        This component has no Instances
      </p>
    </div>
    <form v-if="!getLoading && hasContent && hasInstance">
      <h6
        v-if="
          getBasicAttributes ? Object.keys(getBasicAttributes).length : null
        "
        class="text-blueGray-400 text-sm mt-3 ml-4 mb-6 font-bold uppercase"
      >
        Basic
      </h6>
      <div class="flex flex-wrap">
        <div
          v-for="(value, name) in getBasicAttributes"
          :key="name"
          class="w-full lg:w-4/12 px-4"
        >
          <div v-if="value.type === 'short_text'" class="relative w-full mb-3">
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(name)"
                :description="value.description"
              />
            </label>
            <input
              type="text"
              v-model="formDataLocal[name]"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            />
          </div>
          <div
            v-else-if="value.type === 'select' || value.type === 'boolean'"
            class="relative w-full mb-3"
          >
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(name)"
                :description="value.description"
              />
            </label>
            <select
              v-model="formDataLocal[name]"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            >
              <option
                v-for="(option, index) in changeOptionsFormat(value.options)"
                :key="index"
                :value="option.value"
              >
                {{ option.label }}
              </option>
            </select>
          </div>
          <div v-else-if="value.type === 'url'" class="relative w-full mb-3">
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(name)"
                :description="value.description"
              />
            </label>
            <URLInput
              :url="formData[name] ? formData[name] : ''"
              @update:url="(val) => handleUpdateValue(val, name)"
            />
          </div>
          <div v-else-if="value.type === 'icon'" class="relative w-full mb-3">
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(name)"
                :description="value.description"
              />
            </label>
            <IconPicker
              :icons="value.options"
              :icon="formData[name] ? formData[name] : ''"
              @update:icon="(val) => handleUpdateValue(val, name)"
            />
          </div>
          <div v-else class="relative w-full mb-3">
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(name)"
                :description="value.description"
              />
            </label>
            <input
              v-model="formDataLocal[name]"
              type="text"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            />
          </div>
        </div>
      </div>
      <hr
        v-if="
          getBasicAttributes &&
          Object.keys(getBasicAttributes).length &&
          getAdditionalAttributes &&
          Object.keys(getAdditionalAttributes).length
        "
        class="mt-6 border-b-1 border-blueGray-300"
      />
      <h6
        v-if="
          getAdditionalAttributes
            ? Object.keys(getAdditionalAttributes).length
            : null
        "
        class="text-blueGray-400 text-sm mt-3 ml-4 mb-6 font-bold uppercase"
      >
        Additional
      </h6>
      <div class="flex flex-wrap">
        <div
          v-for="(value, name) in getAdditionalAttributes"
          :key="name"
          class="w-full lg:w-12/12 px-4"
        >
          <div v-if="value.type === 'long_text'" class="relative w-full mb-3">
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(name)"
                :description="value.description"
              />
            </label>
            <ckeditor
              v-if="
                componentId === getComponentId('abi_title_image_text') ||
                componentId === getComponentId('abi_hero_text_blade') ||
                componentId === getComponentId('abi_content_text_block') ||
                componentId ===
                  getComponentId('abi_flexible_alignment_text_block')
              "
              class="h-40 border-0 px-3 py-3 placeholder-blueGray-300 bg-white rounded shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
              :editor="editor"
              :config="editorConfig"
              v-model="formDataLocal[name]"
            />
            <textarea
              v-else
              type="text"
              v-model="formDataLocal[name]"
              class="h-40 border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@/assets/ckeditor/build/ckeditor";
import * as Constants from "@/store/constants";
import URLInput from "@/components/Shared/Input/URLInput";
import IconPicker from "@/components/Shared/Input/IconPicker";
import AttrTitleWithDescription from "@/components/Shared/Headers/AttrTitleWithDescription";

export default {
  name: "BasicComponentForm",
  components: {
    ckeditor: CKEditor.component,
    URLInput,
    IconPicker,
    AttrTitleWithDescription
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: Constants.CK_EDITOR_CONFIG
    };
  },
  props: {
    formData: {
      type: Object,
      required: true
    },
    componentId: {
      type: String,
      required: true
    }
  },
  computed: {
    formDataLocal: {
      get: function () {
        return this.formData;
      },
      set: function (val) {
        this.$emit("update:formData", val);
      }
    },
    hasContent() {
      if (
        this.getBasicAttributes &&
        this.getAdditionalAttributes &&
        Object.keys(this.getBasicAttributes).length +
          Object.keys(this.getAdditionalAttributes).length ===
          0
      ) {
        return false;
      } else {
        return true;
      }
    },
    hasInstance() {
      if (this.getInstanceInfo) {
        return !!this.getInstanceInfo.length;
      } else {
        return false;
      }
    },
    ...mapGetters([
      "getLoading",
      "getBasicAttributes",
      "getAllComponent",
      "getAdditionalAttributes",
      "getInstanceInfo"
    ])
  },
  emits: ["update:formData"],
  methods: {
    formatAttrName(name) {
      const nameArray = name.split("_");
      nameArray.splice(0, 2);
      return nameArray.join(" ");
    },
    changeOptionsFormat(options) {
      const newOptions = options.map((item) => {
        return { label: item, value: item };
      });
      return newOptions;
    },
    handleUpdateValue(val, name) {
      this.formDataLocal[name] = val;
    },
    getComponentId(componentName) {
      if (this.getAllComponent.find((item) => item.name === componentName)) {
        return this.getAllComponent.find((item) => item.name === componentName)
          .id;
      } else {
        return null;
      }
    }
  }
};
</script>
